import { posterOverviewSchema, type PosterOverview } from '@teentack/shared';
import { apiFetch } from '@/lib/api-client';

/** Everything the job poster console renders, in one call. */
export async function fetchPosterOverview(): Promise<PosterOverview> {
  return posterOverviewSchema.parse(await apiFetch<unknown>('/poster/overview'));
}
